import BannerComp from "../../components/BannerComp";
import FeatureCard from "../../components/FeatureCard";
import FeatureFlow from "../../components/FeatureFlow";
import FeatureImageContent from "../../components/FeatureImageContent";
import ImageTextSection from "../../components/ImageTextSection";
import Seo from "../../components/Seo";
import { featuresCardData, stepper } from "../../data/flowseven";
import { createBreadcrumbSchema, createWebPageSchema } from "../../lib/seo";

import section1Image from "./flow7_section1.webp";
import section2Image from "./flow7_section2.webp";
import section3Image from "./flow7_section3.webp";

const seo = {
  title: "Flow 7 Advanced Testing | MIT4Doctors",
  description:
    "This tool analyzes vascular function and the autonomic nervous system, encouraging collaboration between primary care and specialty physicians for better care.",
  schema: [
    createWebPageSchema({
      path: "/services/tm-flow-testing-dysfunction",
      title: "Flow 7 Advanced Testing",
      description:
        "This tool focuses on analyzing vascular function and the autonomic nervous system, and it encourages collaboration between primary care and specialty physicians to provide exceptional care.",
    }),
    createBreadcrumbSchema(
      "/services/tm-flow-testing-dysfunction",
      "Flow 7 Advanced Testing",
    ),
  ],
};

export default function Flow7TestingDysfunction() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        canonicalPath="/services/tm-flow-testing-dysfunction"
        schema={seo.schema}
      />
      <BannerComp
        heading="Flow 7 Advanced Testing"
        subHeading="Autonomic Neuropathy & Vascular Dysfunction"
        paragraph="This tool focuses on analyzing vascular function and the autonomic nervous system, and it encourages collaboration between primary care and specialty physicians to provide exceptional care."
        centered
        BannerBgImg="/img/banners/flowseven_hero.webp"
      />

      <ImageTextSection
        image={section1Image}
        imageAlt="How the Flow 7 System Works"
        imagePosition="left"
        title="How the Flow 7 System Works"
        description="The Flow 7 System allows the measurement of a patient's health in minutes. Blood in the vessels is a sign of vascular health. Nerves transmit signals, revealing automatic responses. Data from these sources form a complete picture. The treatment uses three tools: vascular analysis, nervous system tests, and combined insights. This technology unlocks the body's secrets, improving outcomes."
        highlightWords="System Works"
      />

      <FeatureCard
        sectionTitle="What Devices We Used and Their Functions"
        sectionDescription="Our testing process uses advanced devices to measure brain activity, autonomic nervous system function, and vascular health. Each device provides valuable insights that help identify functional patterns and support a more personalized approach to assessment and care."
        highlightText="Functions"
        features={featuresCardData}
      />

      <FeatureImageContent
        heading="Take the Next Step"
        description="Improve patient care and expand your diagnostic capabilities with the Flow 7 System. MITSI provides a proven solution. It delivers results for your practice and patients."
        buttonLabel="Get Started"
        buttonUrl="/contact-us"
        imageAlt="Take the Next Step"
      />

      <ImageTextSection
        image={section2Image}
        imageAlt="Financial Benefits"
        imagePosition="left"
        title="Financial Benefits"
        highlightWords="Benefits"
        subSections={[
          {
            heading: "A Solution without any Upfront Costs",
            description:
              "With our innovative pricing model, there’s no need for upfront investment. The flat per-use rate covers the Flow 7 system, technician fees, and billing services. Medicare reimburses $200-$300 per test based on CPT codes. Many insurance firms cover this tool. So, it is an affordable way to improve your practice's diagnostics.",
          },
        ]}
      />

      <FeatureFlow
        heading="Advantages of the Flow 7 System"
        highlights={["Flow", "7", "System"]}
        paragraph="The Flow 7 System detects autonomic neuropathies and vascular dysfunction early. It helps healthcare providers find and fix health issues before they worsen. By spotting these conditions early, the system helps prevent complications."
        steps={stepper}
      />

      <ImageTextSection
        image={section3Image}
        imageAlt="Tap Into Advanced Diagnostics with Flow 7"
        imagePosition="left"
        title="Tap Into Advanced Diagnostics with Flow 7"
        subSections={[
          {
            heading: "Contact us today.",
            description:
              "We'll show you how the Flow 7 System can boost your practice's diagnostic skills. Improve patient care, ease testing, and get accurate results faster with our integrated solution. Reach out now!",
          },
        ]}
        highlightWords="Flow 7"
      />
    </>
  );
}
